import React from 'react';
import styled from 'styled-components';
import Composer from 'react-composer/dist/react-composer';

import BaseComponent from '../lib/base-component';
import Description, { DescriptionChild } from '../components/description';
import ContentBlock from '../components/content-block';
import SectionTitle, { SectionTitleChild } from '../components/section-title';
import { Text } from '../fitbit-components';

import {
  SectionContainer as OriginalSectionContainer,
  SectionBody as OriginalSectionBody
} from '../components/Common';

const SectionContainer = styled(OriginalSectionContainer)`
  ${({ noMargin }) => noMargin ? `
    margin: 0;
  ` : ''}
`;

// Make sure back to back Text components do not
// render with lines inbetween on iOS
const SectionBody = styled(OriginalSectionBody)`
  .text + .text {
    border: none;
  }

  ${({ noPadding }) => noPadding ? `
    padding: 0;
  ` : ''}

  ${({ noTopBorder }) => noTopBorder ? `
    border-top: none;
  ` : ''}
`;

const SectionInner = ({ type, ...props }) => (
  <ContentBlock className={type} {...props} />
);

const SectionWrapper = ({ title, description, ...props }) => (
  <Section title={title} description={description}>
    <SectionInner {...props} />
  </Section>
);

export const SectionContext = React.createContext({
  isNested: false,
  ChildWrapper: SectionWrapper
});

export const SectionChild = (props) => (
  <Composer
    components={[
      <SectionContext.Consumer />,
      <DescriptionChild />,
      <SectionTitleChild />
    ]}
  >
    {([ { ChildWrapper }, inDescription, inTitle ]) =>
      <ChildWrapper collapse={inDescription || inTitle} {...props} />}
  </Composer>
);

// This is for when a Fitbit component is used in Select or
// AdditiveList so they prevent the normal SectionChild behavior
export const DisabledSection = (props) => (
  <SectionContext.Provider
    value={{ isNested: true, ChildWrapper: ({ children }) => children }}
    {...props}
  />
);

class Section extends BaseComponent<Props, void> {
  render() {
    const {
      title,
      description,
      className,
      noMargin,
      noPadding,
      noTopBorder,
      children
    } = this.props;

    return (
      <SectionContext.Consumer>
        {({ isNested }) => {
          return isNested ? children : (
            <SectionContext.Provider
              value={{ isNested: true, ChildWrapper: SectionInner }}
            >
              <SectionContainer
                className={className}
                noMargin={noMargin}
              >
                {title && <SectionTitle>{title}</SectionTitle>}
                <SectionBody noTopBorder={noTopBorder} noPadding={noPadding}>
                  {React.Children.map(children, child =>
                    typeof child === 'string' ||
                    typeof child === 'number' ?
                      <Text>{child}</Text> : child
                  )}
                </SectionBody>
                {description && <Description hasPadding>{description}</Description>}
              </SectionContainer>
            </SectionContext.Provider>
          );
        }}
      </SectionContext.Consumer>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/section.js